import { Component, OnInit, AfterContentInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppGlobals } from '../../app.globals';
import { Location, CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';



@Component({
    selector: 'app-error-feedback-component',
    templateUrl: './error-feedback-component.html',
    styleUrls: ['./error-feedback-component.css',],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        DxButtonModule,
    ]
})


export class ErrorFeedbackComponent implements OnInit {

  errorFeedback: any = $localize`:@@someErrorOccured:Some Error Occured`;

  @Output() feedbackResponse = new EventEmitter<any>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appGlobals: AppGlobals,
    private location: Location,
  ) { }

  ngOnInit(): void {
    //this.errorFeedback = AppGlobals.GlobalErrorFeedback

    this.errorFeedbackPopUp(this.errorFeedback);


  }

  errorFeedbackPopUp(value: any): any {
    this.feedbackResponse.emit(value);
  }

  goTo(path: string): void {
    this.router.navigate([path]);
  }


  goBack(): void {
    this.location.back()
  }










}